// removed by extract-text-webpack-plugin
module.exports = {"header":"_-src-components-UserSegments-index---header---3G_pQ","title":"_-src-components-UserSegments-index---title---2HAgc","headerContent":"_-src-components-UserSegments-index---headerContent---h-h4F","loader":"_-src-components-UserSegments-index---loader---Z9jf-","singleColumn":"_-src-components-UserSegments-index---singleColumn---39jw8","twoColumn":"_-src-components-UserSegments-index---twoColumn---1sqrR"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UserSegments/index.css
// module id = 678
// module chunks = 1